import { createComponent } from '@carvana/merch-components';

export const CommonWrapper = createComponent('div', {
  className: 'gap-16 grid p-32'
});

export const ModelWrapper = createComponent('div', {
  className: 'gap-16 grid pb-32'
});

export const TrimWrapper = createComponent('div', {
  className:
    'border-0 border-b-2 border-grey-2 border-solid first:pt-0 gap-16 grid last:border-0 last:pb-0 pb-[35px] pt-32'
});
